/**
 * 공용 삭제 버튼 — 평상시엔 면적을 주지 않고 호버에서만 빨강을 채운다(파괴적 동작).
 * AI 화면의 "행을 지운다"(생산 공정 삭제·기간 삭제 …) 액션 시각 언어를 하나로 통일한다.
 *
 * 테두리는 border 가 아니라 inset 링이다 — 배경색이 바뀌는 1px border 는 둥근 모서리에 잔상이 남는다.
 * 아이콘은 CloseIcon — '×' 글리프는 좌우 사이드베어링이 달라 가운데로 보이지 않는다.
 *
 * @param {boolean}  disabled
 * @param {Function} onClick
 * @param {object}   sx  배치용 오버라이드
 */
import { Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { C } from "@plannel/components/ai/aiTokens";

export function AiDeleteButton({ disabled, onClick, sx }) {
  return (
    <Box component="button" type="button" disabled={disabled} onClick={onClick}
      sx={{ flex: "0 0 auto", display: "inline-flex", alignItems: "center", justifyContent: "center",
            width: 18, height: 18, p: 0, boxSizing: "border-box", appearance: "none",
            borderRadius: "6px", border: "none", bgcolor: C.bg2, color: C.text3,
            boxShadow: `inset 0 0 0 1px ${C.border}`,
            cursor: disabled ? "not-allowed" : "pointer", opacity: disabled ? 0.45 : 1,
            "&:hover": disabled ? {}
              : { bgcolor: C.g3, color: "#fff", boxShadow: `inset 0 0 0 1px ${C.g3}` },
            ...sx }}>
      <CloseIcon sx={{ fontSize: 12 }} />
    </Box>
  );
}

export default AiDeleteButton;
